import React, { useState, useContext, useMemo, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import CEECampaignsContext from "context/CEECampaignsContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

import UserService from "services/UserService";
import axios from "axios";
import { getCeecampaignFiles } from "services/ConfigServices";
import { ceecampaignfiles } from "variables/cee";
import moment from "moment";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";
import CreateElementfiles from "./CreateElementfiles";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

export default function useElementfilesTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const ceeCampaignContext = useContext(CEECampaignsContext);
  const { ceecampaign } = ceeCampaignContext;
  const ceeadmin = permis.includes("cee_admin") && ceecampaign.ceecampaignAdminVisibility;
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  
  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const url = getCeecampaignFiles(chartIdGroup, ceecampaign.id, 'elementfiles');
  const [results, setResults] = useState({});
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedElementFiles, setSelectedElementFiles] = useState([]);

  const refreshTable = () =>
  {
    setRefresh(!refresh);
  }

  //Ok but should not be able to change group at this level
  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (chartIdGroup && chartIdGroup[0] !== "0") 
    { 
      if((prevIdGroup && prevIdGroup === chartIdGroup)
      && (prevRefresh && prevRefresh === refresh))
      {
        return;
      }
      //setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          url,        
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        setResults(response.data);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = chartIdGroup;
      fetchData();
    }
  }, [chartIdGroup,refresh]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const filteredItems = _.get(results, `files`, []).filter(
    (item) =>
    (item.parameters.doctype && item.parameters.doctype.toLowerCase().includes(filterText.toLowerCase())) ||
    (item.parameters.description && item.parameters.description.toLowerCase().includes(filterText.toLowerCase())) ||
    (item.parameters.docname && item.parameters.docname.toLowerCase().includes(filterText.toLowerCase()))   
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = selectedElementFiles.map((item) => {
      let elementfiletoexport = {};
      elementfiletoexport[ceecampaignfiles.doctype] = item.parameters.doctype;
      elementfiletoexport[ceecampaignfiles.docname] = item.parameters.docname;
      elementfiletoexport[ceecampaignfiles.description] = item.parameters.description;
      return elementfiletoexport;
    });
    return (
      <>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {ceeadmin && (
          <UploadButton type="button" onClick={handleClear}>
          <CreateElementfiles refetch={refreshTable}  onClick={handleClear}/>
        </UploadButton>
        )}
        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!selectedElementFiles || selectedElementFiles.length < 1} />
        </UploadButton>
      </>
    );
  }, [filterText, resetPaginationToggle, selectedElementFiles]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refetch: refreshTable,
    setSelectedElementFiles
  };
}
